export function getApiURL() {
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}
	return "http://app.goaccounts.local";
}

export function getTokenClientId() {
	if (process.env.REACT_APP_CLIENT_ID) {
		return process.env.REACT_APP_CLIENT_ID;
	}

	return "client_id_ajax_dev";
}

export function getTokenClientSecret() {
	if (process.env.REACT_APP_CLIENT_SECRET) {
		return process.env.REACT_APP_CLIENT_SECRET;
	}

	return "client_secret_ajax_dev";
}

export function isLocal() {
	const apiURL = getApiURL();
	if (apiURL.includes(".local")) {
		return true;
	}
	return false;
}

export function getCrashReportApiToken() {
	if (process.env.REACT_APP_CRASHREPORT_TOKEN) {
		return process.env.REACT_APP_CRASHREPORT_TOKEN;
	}

	return "test-token";
}

export function getGoogleAnalyticsId() {
	if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
		return process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
	}
	return undefined;
}
